import { render, staticRenderFns } from "./OneCategoryTreeItem.vue?vue&type=template&id=8064dc20&scoped=true&lang=pug&"
import script from "./OneCategoryTreeItem.vue?vue&type=script&lang=ts&"
export * from "./OneCategoryTreeItem.vue?vue&type=script&lang=ts&"
import style0 from "./OneCategoryTreeItem.vue?vue&type=style&index=0&id=8064dc20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_vd7qwssw5i3h3fjzjs5bz4d2ha/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8064dc20",
  null
  
)

export default component.exports